import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Reader } from '@thiememeulenhoff/types';
import { ReadersEndpointService } from './readers.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class ReadersService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(ReadersEndpointService);

  fetchReaders() {
    return this.#http.get<Array<Reader>>(this.#endpoints.readers());
  }

  fetchReader(readerId: string) {
    return this.#http.get<Reader>(this.#endpoints.reader(readerId));
  }

  updateReader(
    readerId: string,
    readerTitle: string,
    schoolName: string,
    description: string,
  ) {
    return this.#http.put(this.#endpoints.updateReader(readerId), {
      title: readerTitle,
      schoolName,
      description,
    });
  }
}
